import React from "react";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import DialogContent from "@mui/material/DialogContent";
import { Typography, Box, Paper } from "@mui/material";
import ResponsiveButton from "../../../Forms/ResponsiveButton";
import CloseIcon from "@mui/icons-material/Close";

const UserGuideModal = ({ guideModalOpen, setGuideModalOpen }) => {
  const onClose = () => setGuideModalOpen(false);

  const handleClick = (label) => {
    onClose();
    console.log(`${label} clicked!`);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    color: "#167bc3",
    transform: "translate(-50%, -50%)",
    width: "50%",
    maxWidth: 500,
    backgroundColor: "white",
    borderRadius: "12px",
    padding: "1rem 1.5rem",
  };

  const sections = [
    {
      title: "TRAYS",
      items: ["A. Trays List", "B. Tray Image Data Review"],
    },
    {
      title: "COLLECTION DETAILS",
      items: [
        "A. Collection Sites",
        "B. Collection Methods",
        "C. Modify Collection Details",
      ],
    },
    {
      title: "REPORTS",
      items: ["A. Types of Reports", "B. How to Use a Report"],
    },
    {
      title: "SETUP",
      items: ["A. Wifi Setup"],
    },
    {
      title: "SETTINGS",
      items: ["A. General Settings"],
    },
  ];

  return (
    <Modal
      open={guideModalOpen}
      onClose={onClose}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <DialogContent>
        <div style={style} className="transition-opacity duration-1000">
          <Box
            sx={{
              mb: 2,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <ResponsiveButton
              variant="contained"
              color="primary"
              style={{
                color: "#167bc3",
                backgroundColor: "#ffffff",
                border: "1px solid rgba(22, 123, 195, 0.3)",
                // boxShadow: "4px 4px 8px rgba(0, 0, 0, 0.2)",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem",
                minWidth: "unset",
              }}
              onClick={onClose}
            >
              <CloseIcon />
            </ResponsiveButton>
          </Box>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: ["1.2rem", "1.5rem", "1.5rem", "1.8rem"],
              textAlign: "center",
              marginBottom: "0.1rem",
            }}
          >
            Welcome to User Guides!
            <br />
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: ["1rem", "1rem", "1rem", "1rem"],
              textAlign: "center",
              marginBottom: "1.5rem",
            }}
          >
            What part of the website would you like a guide on today?
          </Typography>


          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              maxHeight: "60vh",
              overflowY: "scroll",
              "&::-webkit-scrollbar": {
                borderTop: "1px solid #e9e9ec",
                height: "5px",
                width: "5px",
              },
              "&::-webkit-scrollbar-thumb:horizontal": {
                borderRadius: "15px",
                backgroundColor: "rgba(0,0,0,0.25)",
              },
              "&::-webkit-scrollbar-thumb:vertical": {
                borderRadius: "15px",
                backgroundColor: "rgba(0,0,0,0.25)",
                minHeight: "20px",
                height: "20px",
              },
              pr: 1,
            }}
          >
            {sections.map((section) => (
              <Paper
                key={section.title}
                elevation={3}
                sx={{
                  padding: 1.5,
                  borderRadius: 3,
                  background: "rgba(22, 123, 195, 0.08)",
                  color: "#167bc3",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  cursor: "default",
                }}
              >
                <Typography
                  variant="h7"
                  sx={{
                    textAlign: "left",
                    fontWeight: "bold",
                    mb: 0.5,
                    // cursor: "pointer",
                    pl: 2,
                  }}
                // onClick={() => handleClick(section.title)}
                >
                  {section.title}
                </Typography>

                {section.items.map((item) => (
                  <Typography
                    key={item}
                    sx={{
                      fontSize: "1rem",
                      mb: 1,
                      pl: 2,
                      cursor: "pointer",
                      color: "#167bc3",
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                    onClick={() => handleClick(item)}
                  >
                    {item}
                  </Typography>
                ))}
              </Paper>
            ))}
          </Box>
        </div>
      </DialogContent>
    </Modal>
  );
};

export default UserGuideModal;
